<template>
  <div class="uk-container uk-text-center">
    <div class="uk-grid aire uk-child-width-expand@s" uk-grid>

      <div>
        <a @click="$router.push({ path: '/modelos' })" class="susuki-button uk-align-center uk-text-center">Cotízalo</a>
      </div>

      <div>
        <a @click="$router.push({ path: '/PruebaDeManejo' })" class="susuki-button uk-align-center uk-text-center">Manéjalo</a>
      </div>

      <div>
        <a @click="$router.push({ path: '/contacto' })" class="susuki-button uk-align-center uk-text-center">Visítanos</a>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "Buttons",
  };
</script>

<style lang="scss" >
</style>
